import { createFileRoute, redirect } from "@tanstack/react-router";

import { PartnerTermsPage } from "@/components/marketing/partner-terms-page";
import { MARKETING_FLAGS } from "@/lib/marketing-flags";
import { pageHead } from "@/lib/seo";

export const Route = createFileRoute("/(public)/partners/terms")({
  beforeLoad: () => {
    if (!MARKETING_FLAGS.partners) {
      throw redirect({ to: "/" });
    }
  },
  head: () => pageHead("partnersTerms"),
  component: PartnerTermsPage,
});
